(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["De-la-Main-fuznet"] && !Shopify.designMode) return;
  try {
    
(function () {
  var targets = document.querySelectorAll('[data-epopee-animate]');
  if (!targets.length) return;
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15 });
  targets.forEach(function (t) { observer.observe(t); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Heures-Fuznet"] && !Shopify.designMode) return;
  try {
    
(function () {
  /* Fade-in animation */
  var targets = document.querySelectorAll('[data-epopee-animate]');
  if (targets.length) {
    var fadeObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          fadeObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });
    targets.forEach(function (t) { fadeObserver.observe(t); });
  }

  /* Counter animation */
  var counters = document.querySelectorAll('[data-epopee-count]');
  if (!counters.length) return;

  var countObserver = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var el = entry.target;
      var target = parseInt(el.getAttribute('data-epopee-count'), 10);
      var duration = 2500;
      var start = performance.now();

      function step(now) {
        var progress = Math.min((now - start) / duration, 1);
        var eased = 1 - Math.pow(1 - progress, 3);
        el.textContent = Math.round(eased * target);
        if (progress < 1) requestAnimationFrame(step);
      }

      requestAnimationFrame(step);
      countObserver.unobserve(el);
    });
  }, { threshold: 0.3 });

  counters.forEach(function (c) { countObserver.observe(c); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Savoir-Faire"] && !Shopify.designMode) return;
  try {
    
(function () {
  var targets = document.querySelectorAll('[data-epopee-animate]');
  if (!targets.length) return;
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15 });
  targets.forEach(function (t) { observer.observe(t); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collaborations-fuznet"] && !Shopify.designMode) return;
  try {
    
(function () {
  var init = function () {
    var targets = document.querySelectorAll('[data-collab-animate]');
    if (!targets.length) return;
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry, i) {
        if (entry.isIntersecting) {
          setTimeout(function () { entry.target.classList.add('is-visible'); }, i * 90);
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });
    targets.forEach(function (t) { observer.observe(t); });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact"] && !Shopify.designMode) return;
  try {
    
(function() {
  var form = document.getElementById('epopee-contact-form');
  var wrapper = document.getElementById('epopee-contact-form-wrapper');
  var success = document.getElementById('epopee-contact-success');
  var resetBtn = document.getElementById('epopee-contact-reset');
  var select = document.getElementById('epopee-subject');

  if (select) {
    try {
      var wanted = new URLSearchParams(window.location.search).get('subject');
      if (wanted) {
        var normalized = wanted.toLowerCase();
        for (var i = 0; i < select.options.length; i++) {
          var opt = select.options[i];
          if (!opt.value) continue;
          if (opt.value.toLowerCase() === normalized || opt.text.toLowerCase() === normalized) {
            select.selectedIndex = i;
            break;
          }
        }
      }
    } catch (e) {}
  }

  if (success && success.style.display !== 'none' && window.location.hash !== '#contact-success') {
    success.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  if (resetBtn) {
    resetBtn.addEventListener('click', function() {
      if (form) form.reset();
      if (success) success.style.display = 'none';
      if (wrapper) wrapper.style.display = 'block';
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-why-choose-me"] && !Shopify.designMode) return;
  try {
    
(function () {
  var init = function () {
    var targets = document.querySelectorAll('[data-whyme-animate]');
    if (!targets.length) return;
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry, i) {
        if (entry.isIntersecting) {
          setTimeout(function () {
            entry.target.classList.add('is-visible');
          }, i * 120);
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });
    targets.forEach(function (t) { observer.observe(t); });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["expertise-fuznet"] && !Shopify.designMode) return;
  try {
    
(function () {
  var targets = document.querySelectorAll('[data-epopee-animate]');
  if (!targets.length) return;
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15 });
  targets.forEach(function (t) { observer.observe(t); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["export-page-savoir-faire-fuznet"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init() {
    var targets = document.querySelectorAll('[data-sf-animate]');
    if (!targets.length) return;
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });
    targets.forEach(function (t) { observer.observe(t); });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["inspiration-fuznet"] && !Shopify.designMode) return;
  try {
    
(function () {
  var targets = document.querySelectorAll('[data-epopee-animate]');
  if (!targets.length) return;
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15 });
  targets.forEach(function (t) { observer.observe(t); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["matieres-fuznet"] && !Shopify.designMode) return;
  try {
    
(function () {
  var targets = document.querySelectorAll('[data-epopee-animate]');
  if (!targets.length) return;
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15 });
  targets.forEach(function (t) { observer.observe(t); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nav-fuznet"] && !Shopify.designMode) return;
  try {
    
(function() {
  var navbar = document.getElementById('epopee-navbar');
  var hamburger = document.getElementById('epopee-hamburger');
  var overlay = document.getElementById('epopee-mobile-overlay');
  var iconMenu = document.getElementById('epopee-icon-menu');
  var iconClose = document.getElementById('epopee-icon-close');
  if (!navbar || !hamburger) return;

  var isOpen = false;

  hamburger.addEventListener('click', function() {
    isOpen = !isOpen;
    overlay.classList.toggle('open', isOpen);
    navbar.classList.toggle('menu-open', isOpen);
    iconMenu.style.display = isOpen ? 'none' : 'block';
    iconClose.style.display = isOpen ? 'block' : 'none';
    document.body.style.overflow = isOpen ? 'hidden' : '';
  });

  window.addEventListener('scroll', function() {
    if (window.scrollY > 80) {
      navbar.classList.add('scrolled');
    } else {
      navbar.classList.remove('scrolled');
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["qui-suis-je"] && !Shopify.designMode) return;
  try {
    
(function () {
  var targets = document.querySelectorAll('[data-qui-animate]');
  if (!targets.length) return;
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15 });
  targets.forEach(function (t) { observer.observe(t); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["technique-details-fuznet"] && !Shopify.designMode) return;
  try {
    
(function () {
  var targets = document.querySelectorAll('[data-epopee-animate]');
  if (!targets.length) return;
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15 });
  targets.forEach(function (t) { observer.observe(t); });
})();

  } catch(e) { console.error(e); }
})();
})();
